import { defineNuxtPlugin } from '#app'
import {
  getScrollbarWidth,
  useDebounceFn,
  useLayoutStore,
  useNuxtApp
} from '#imports'

const checkSizes = () => {
  const iw = window.innerWidth
  const ih = window.innerHeight

  let bp = null
  let mobile = null

  if (iw < 768) {
    bp = 'mobile'
  } else if (iw < 1024) {
    bp = 'tablet'
  } else if (iw < 1280) {
    bp = 'medium'
  } else if (iw < 1440) {
    bp = 'large'
  } else if (iw < 1920) {
    bp = 'wide'
  } else {
    bp = 'huge'
  }

  if (iw < 1024) {
    mobile = true
  } else {
    mobile = false
  }

  return {
    iw, ih, bp, mobile
  }
}

export default defineNuxtPlugin({
  parallel: true,
  setup () {
    // console.log('[NUXT] 21.layout.client.js')
    const { bus } = useNuxtApp()
    const store = useLayoutStore()
    const {
      iw, ih, bp, mobile
    } = checkSizes()

    store.breakpoint = bp
    store.mobile = mobile
    store.width = iw
    store.height = ih

    bus.emit('layout:resize')

    store.scrollbarWidth = getScrollbarWidth()

    window.addEventListener('resize', useDebounceFn(() => {
      const {
        iw, ih, bp, mobile
      } = checkSizes()

      store.breakpoint = bp
      store.mobile = mobile
      store.width = iw
      store.height = ih

      // if (!mobile && !(store.state.dev.isSafari && store.state.dev.isTouch)) { app.bus.emit('scrolltrigger:refresh') }
      store.scrollbarWidth = getScrollbarWidth()
      bus.emit('layout:resize')
    }, 150))
  }
})
